import React from 'react';
import { TableRow, TableCell, Checkbox, IconButton, Chip, Avatar, Typography, Box } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import dayjs from 'dayjs';

const ProjectsTableRow = ({
    project,
    index,
    perms,
    selectedIds,
    onRowCheckboxClick,
    onMenuOpen,
    page,
    perPage,
    isArabic,
}) => {
    const isSelected = selectedIds.includes(project.id);

    return (
        <TableRow hover selected={isSelected}>
            <TableCell padding="checkbox">
                <Checkbox
                    checked={isSelected}
                    onClick={(event) => onRowCheckboxClick(event, project.id)}
                />
            </TableCell>

            {/* S/N */}
            <TableCell align={isArabic ? 'right' : 'left'}>
                {(page - 1) * perPage + index + 1}
            </TableCell>

            {/* العنوان مع الصورة */}
            <TableCell align={isArabic ? 'right' : 'left'}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    {project.main_image && (
                        <Avatar
                            src={project.main_image}
                            alt={isArabic ? (project.title?.ar || project.title) : (project.title?.en || project.title)}
                            sx={{ width: 40, height: 40 }}
                            variant="rounded"
                        />
                    )}
                    <Box>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            {isArabic
                                ? (project?.title?.ar || project?.title?.en || (typeof project?.title === 'string' ? project.title : '-'))
                                : (project?.title?.en || project?.title?.ar || (typeof project?.title === 'string' ? project.title : '-'))
                            }
                        </Typography>
                    </Box>
                </Box>
            </TableCell>

            {/* Slug */}
            <TableCell align={isArabic ? 'right' : 'left'}>
                {project?.slug
                    ? <Chip label={project.slug} size="small" variant="outlined" sx={{ borderRadius: '6px', fontWeight: 'bold', fontFamily: 'monospace' }} />
                    : '-'
                }
            </TableCell>

            {/* العميل */}
            <TableCell align={isArabic ? 'right' : 'left'}>
                {project?.client
                    ? (isArabic
                        ? (project.client.title?.ar || project.client.title?.en || (typeof project.client.title === 'string' ? project.client.title : '-'))
                        : (project.client.title?.en || project.client.title?.ar || (typeof project.client.title === 'string' ? project.client.title : '-')))
                    : '-'
                }
            </TableCell>

            {/* عرض في الرئيسية */}
            <TableCell align="center">
                <Chip
                    label={project?.show_in_home ? (isArabic ? 'نعم' : 'Yes') : (isArabic ? 'لا' : 'No')}
                    size="small"
                    color={project?.show_in_home ? 'primary' : 'default'}
                    variant="outlined"
                    sx={{ borderRadius: '6px' }}
                />
            </TableCell>

            {/* ترتيب */}
            <TableCell align="center">
                {project?.sort_order ?? '-'}
            </TableCell>

            {/* تاريخ الإضافة */}
            <TableCell align={isArabic ? 'right' : 'left'} sx={{ whiteSpace: 'nowrap' }}>
                {project?.created_at ? dayjs(project.created_at).format('YYYY-MM-DD') : '-'}
            </TableCell>

            {/* الإجراءات */}
            <TableCell align="center">
                <IconButton onClick={(event) => onMenuOpen(event, project)}>
                    <MoreVertIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default ProjectsTableRow;
